<template>
  <div class="wc-dashboard-window d-flex flex-column w-100">
    <WCTitle class="d-flex justify-content-between align-items-center p-4">
      <h2>
        <slot name="title" />
      </h2>
      <div>
        <slot name="title-right" />
      </div>
    </WCTitle>
    <div class="wc-account-window-desktop__body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import WCTitle from '@/components/WCTitle/WCTitle.vue';

export default {
  name: 'DashboardWindow',
  components: { WCTitle },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-dashboard-window {
  position: relative;
  min-height: 22.5rem; /* Holding some min-height to avoid loader being overlapping with the title */
}

.wc-account-window-desktop__body {
  background-color: var(--secondary-lighter-9, $light);
  ::v-deep .wc-account-window-section-desktop {
    // Remove potential top-gutter from body elements
    &:first-child {
      margin-top: 0 !important;
    }
    // Remove potential bottom-gutter from body elements
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
